import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatLocationName } from '../../core/util/location';
import { isEmpty } from '../../core/util/empty';
import { safeGet } from '../../core/util/object';

class ClinicLogo extends PureComponent {
  render = () => {
    const logos = safeGet(this.props)('location.imageLinks.logo');
    if (isEmpty(logos)) {
      return (
        <div className={this.props.className}>
          <h2>{formatLocationName(this.props.location)}</h2>
        </div>
      );
    }

    return (
      <div className={this.props.className}>
        <img
          itemProp="image"
          src={logos[0]}
          height={this.props.height}
          role="presentation"
          alt={this.props.alt}
        />
      </div>
    );
  };
}

ClinicLogo.propTypes = {
  location: PropTypes.object.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  height: PropTypes.number.isRequired,
};

ClinicLogo.defaultProps = {
  height: 49,
};

export default ClinicLogo;
